import React, { useState, useEffect, useMemo, useRef } from 'react';

import { setNetworkErrorHandler } from 'services/ajax-service';
import { remoteLog } from 'shared-services/logger-service';

const doInternetCheck = () => {
    return fetch((`https://nifty.pm/version?_t=${parseInt(Math.random() * 10000)}`));
}

export const NetworkConnectionContext = React.createContext();

export const NetworkConnectionProvider = ({ children }) => {
    const [isOnline, setIsOnline] = useState(true);
    const [isInternetConnected, setIsInternetConnected] = useState(true);
    const interval = useRef(null);

    const handleOnline = () => {
        setIsOnline(true);

        checkInternet();
    }

    const handleOffline = () => {
        setIsOnline(false);
    }

    const checkInternet = async () => {
        try {
            await doInternetCheck()
            setIsInternetConnected(true);
        } catch (e) {
            setIsInternetConnected(false);
            remoteLog(`NETWORK CONNECTION ERROR | TEST`);
        }
    }

    const connected = useMemo(() => isOnline && isInternetConnected, [isOnline, isInternetConnected]);

    useEffect(() => {
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        setNetworkErrorHandler(() => {
            setIsInternetConnected(false);
        });
    }, []);

    useEffect(() => {
        if (interval.current) {
            clearInterval(interval.current);
        }

        // interval.current = setInterval(() => {
        //     checkInternet()
        // }, connected ? 60000 : 30000);
    }, [connected]);

    const value = useMemo(() => ({
        connected
    }), [connected]);

    return (
        <NetworkConnectionContext.Provider value={value}>
            { children }
        </NetworkConnectionContext.Provider>
    );
}
